import { all, call } from 'redux-saga/effects';
import furnitureSaga, {
  callBackUpdateSaga,
  displayFurnitureSaga,
  removeCabinetSaga,
} from 'containers/Configurator/sagas/furniture';
import piecesSaga from './pieces';
import colorsSaga from './colors';
import historySaga from './history';
import { changeSaga } from 'containers/Configurator/sagas/change';
import {
  depthSaga,
  widthSaga,
} from 'containers/Configurator/sagas/changes/dimensions';
import ActionTypes from 'containers/Configurator/constants/furniture';
import {
  addPieceFailureAction,
  addShelfFailure,
  removeShelfFailure,
  setCornersFailure,
  setDepthFailure,
  setShelfHeightFailure,
  setSupportFailure,
  setWidthFailure,
} from 'containers/Configurator/actions/furniture';
import {
  addingShelfSaga,
  cornersSaga,
  removingShelfSaga,
  supportSaga,
  fixToWallSaga,
} from 'containers/Configurator/sagas/changes/editCabinet';
import {
  addPieceSaga,
  addPlateSaga,
  addRodsSaga,
  changeCrossPieceSaga,
  compositionSaga,
  drawersSaga,
  drawersUpdateSaga,
  heightShelfsSaga,
  removeCrossPieceSaga,
  removePieceSaga,
  removePlateSaga,
  removeRodsSaga,
  updatingColorSaga,
} from 'containers/Configurator/sagas/changes/editShelf';
import ActionTypesShelvesRibbon from 'containers/Ribbon/ShelvesRibbon/constants';
import ActionTypesColorsPanel from 'containers/PanesPanel/constants';
import { updateColorPaneOnSelectionFailure } from 'containers/PanesPanel/actions';
import ActionTypesISPanel from 'containers/IntermediateShelfPanel/constants';
import ActionTypesHandlePanel from 'containers/HandlesPanel/constants';
import ActionTypesPlatePanel from 'containers/PlatePanel/constants';
import ActionTypeDrawerPanel from 'containers/DrawersPanel/constants';
import ActionTypeCrossPiecePanel from 'containers/CrossPiecePanel/constants';
import ActionTypeRodsOption from 'containers/Ribbon/ShelvesRibbon/ShelvesOptions/RodOption/constants';
import ActionTypePaintPanel from 'containers/PaintPanel/constants';
import ActionConfiguratorMode from 'containers/ModeBar/constants';
import ActionUpperShelfPanel from 'containers/UpperShelfPanel/constants';
import ActionCabinetOptions from 'containers/Ribbon/CabinetRibbon/CabinetOptions/constants';
import {
  addIntermediateShelfSaga,
  colorIntermediateShelfSaga,
  depthIntermediateShelfSaga,
  heightIntermediateShelfSaga,
  removeIntermediateShelfSaga,
} from 'containers/Configurator/sagas/changes/intermediateShef';
import {
  addDoorHandleSaga,
  removeHandleSaga,
  updateDoorHandleSaga,
  updateDrawerHandleSaga,
} from 'containers/Configurator/sagas/changes/handles';
import {
  languageSaga,
  openColorsPanelSaga,
  shelfModeSaga,
  shelfOpenDoorsModeSaga,
} from 'containers/Configurator/sagas/general';
import {
  selectBigDoorsShelvesSaga,
  selectDoorShelvesSaga,
  selectDrawersShelvesSaga,
  selectionShefSaga,
  selectionShelvesSaga,
} from 'containers/Configurator/sagas/selection';
import {
  navigationShelvesSaga,
  switchShelfPositionSaga,
} from 'containers/Configurator/sagas/cabinet';
import {
  applyColorHandleAction,
  applyDeleteSaga,
  applyPaintColorSaga,
} from './changes/editMode';
import {
  addOrUpdateFurnitureUpperShelfSaga,
  addOrUpdateUpperShelfSaga,
  removeFurnitureUpperShelfSaga,
  removeUpperShelfSaga,
} from './changes/upperShelf';

export default function* rootDataSaga() {
  yield all([
    call(furnitureSaga),
    call(colorsSaga),
    call(piecesSaga),
    call(historySaga),
    call(removeCabinetSaga),
    call(openColorsPanelSaga),
    call(selectionShelvesSaga),
    call(selectionShefSaga),
    call(shelfOpenDoorsModeSaga),
    call(languageSaga),
    call(callBackUpdateSaga),
    call(selectDrawersShelvesSaga),
    call(selectDoorShelvesSaga),
    call(selectBigDoorsShelvesSaga),
    call(
      changeSaga(ActionTypes.CABINET_DEPTH_REQUEST, depthSaga, setDepthFailure),
    ),
    call(
      changeSaga(ActionTypes.CABINET_WIDTH_REQUEST, widthSaga, setWidthFailure),
    ),
    call(
      changeSaga(
        ActionTypes.CABINET_CORNER_REQUEST,
        cornersSaga,
        setCornersFailure,
      ),
    ),
    call(
      changeSaga(
        ActionTypes.CABINET_SUPPORT_REQUEST,
        supportSaga,
        setSupportFailure,
      ),
    ),
    call(
      changeSaga(
        ActionTypes.CABINET_ADD_SHELF,
        addingShelfSaga,
        addShelfFailure,
      ),
    ),
    call(
      changeSaga(
        ActionTypes.CABINET_REMOVE_SHELF_REQUEST,
        removingShelfSaga,
        removeShelfFailure,
      ),
    ),
    call(switchShelfPositionSaga),
    call(
      changeSaga(
        ActionTypes.CABINET_SHELF_ADD_PIECE,
        addPieceSaga,
        addPieceFailureAction,
      ),
    ),
    call(
      changeSaga(ActionTypesShelvesRibbon.DELETE_SELECTION, removePieceSaga),
    ),
    call(
      changeSaga(
        ActionTypes.CABINET_SHELFS_HEIGHT_REQUEST,
        heightShelfsSaga,
        setShelfHeightFailure,
      ),
    ),
    call(changeSaga(ActionTypes.CABINET_DRAWERS_COMBINATION, drawersSaga)),
    call(
      changeSaga(ActionTypes.CABINET_SHELF_SET_COMPOSITION, compositionSaga),
    ),
    call(
      changeSaga(
        ActionTypesColorsPanel.UPDATE_COLOR_PANE_ON_SELECTION,
        updatingColorSaga,
        updateColorPaneOnSelectionFailure,
      ),
    ),
    call(
      changeSaga(
        ActionTypesISPanel.ADD_INTERMEDIATE_SHELVES_ON_SELECTION,
        addIntermediateShelfSaga,
      ),
    ),
    call(
      changeSaga(
        ActionTypesISPanel.REMOVE_INTERMEDIATE_SHELVES_ON_SELECTION,
        removeIntermediateShelfSaga,
      ),
    ),
    call(
      changeSaga(
        ActionTypesISPanel.UPDATE_COLOR_INTERMEDIATE_SHELVES_ON_SELECTION,
        colorIntermediateShelfSaga,
      ),
    ),
    call(
      changeSaga(
        ActionTypesISPanel.UPDATE_DEPTH_INTERMEDIATE_SHELVES_ON_SELECTION,
        depthIntermediateShelfSaga,
      ),
    ),
    call(
      changeSaga(
        ActionTypesISPanel.UPDATE_HEIGHT_INTERMEDIATE_SHELVES_ON_SELECTION,
        heightIntermediateShelfSaga,
      ),
    ),
    call(changeSaga(ActionTypesHandlePanel.ADD_HANDLE_DOOR, addDoorHandleSaga)),
    call(
      changeSaga(ActionTypesHandlePanel.REMOVE_HANDLE_DOOR, removeHandleSaga),
    ),
    call(
      changeSaga(
        ActionTypesHandlePanel.UPDATE_HANDLE_DOOR,
        updateDoorHandleSaga,
      ),
    ),
    call(
      changeSaga(
        ActionTypesHandlePanel.UPDATE_HANDLES_DRAWER,
        updateDrawerHandleSaga,
      ),
    ),
    call(changeSaga(ActionTypesPlatePanel.UPDATE_PLATE, addPlateSaga)),
    call(changeSaga(ActionTypesPlatePanel.REMOVE_PLATE, removePlateSaga)),
    call(changeSaga(ActionTypeDrawerPanel.UPDATE_DRAWERS, drawersUpdateSaga)),
    call(navigationShelvesSaga),
    call(displayFurnitureSaga),
    call(shelfModeSaga),
    call(
      changeSaga(
        ActionTypeCrossPiecePanel.ADD_OR_UPDATE_CROSS_PIECE,
        changeCrossPieceSaga,
      ),
    ),
    call(
      changeSaga(
        ActionTypeCrossPiecePanel.REMOVE_CROSS_PIECE,
        removeCrossPieceSaga,
      ),
    ),
    call(changeSaga(ActionTypeRodsOption.REMOVE_RODS, removeRodsSaga)),
    call(changeSaga(ActionTypeRodsOption.ADD_RODS, addRodsSaga)),
    call(
      changeSaga(ActionTypePaintPanel.APPLY_PAINT_COLOR, applyPaintColorSaga),
    ),
    call(changeSaga(ActionConfiguratorMode.APPLY_DELETE, applyDeleteSaga)),
    call(
      changeSaga(
        ActionConfiguratorMode.APPLY_COLOR_HANDLE,
        applyColorHandleAction,
      ),
    ),
    call(
      changeSaga(
        ActionUpperShelfPanel.ADD_OR_UPDATE_UPPER_SHELF,
        addOrUpdateUpperShelfSaga,
      ),
    ),
    call(
      changeSaga(
        ActionUpperShelfPanel.REMOVE_UPPER_SHELF,
        removeUpperShelfSaga,
      ),
    ),
    call(
      changeSaga(
        ActionUpperShelfPanel.ADD_OR_UPDATE_FURNITURE_UPPER_SHELF,
        addOrUpdateFurnitureUpperShelfSaga,
      ),
    ),
    call(
      changeSaga(
        ActionUpperShelfPanel.REMOVE_FURNITURE_UPPER_SHELF,
        removeFurnitureUpperShelfSaga,
      ),
    ),
    call(changeSaga(ActionCabinetOptions.FIX_TO_WALL, fixToWallSaga)),
  ]);
}
